import axios from 'axios';

const resolveBackendUrl = () => {
  const configured = process.env.REACT_APP_BACKEND_URL;
  try {
    const cfgHost = new URL(configured).host;
    const curHost = window.location.host;
    // Tolerate www/apex mismatch (e.g. CDN redirects apex -> www): stay same-origin so CORS/redirects can't break requests.
    if (cfgHost !== curHost && (cfgHost === `www.${curHost}` || curHost === `www.${cfgHost}`)) {
      return window.location.origin;
    }
  } catch (e) { console.warn('Backend URL resolution failed, using configured value', e); }
  return configured;
};

const BACKEND_URL = resolveBackendUrl();
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.response.use(
  (r) => r,
  async (err) => {
    if (err.response?.status === 401 && !err.config._retry) {
      err.config._retry = true;
      try {
        await axios.post(`${API}/auth/refresh`, {}, { withCredentials: true });
        return api(err.config);
      } catch (refreshErr) { console.warn('Token refresh failed', refreshErr?.response?.status); }
    }
    return Promise.reject(err);
  }
);

export function formatApiError(detail) {
  if (detail == null) return 'Something went wrong. Please try again.';
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) return detail.map((e) => (e?.msg ? e.msg : JSON.stringify(e))).join(' ');
  if (detail && typeof detail.msg === 'string') return detail.msg;
  return String(detail);
}

export default api;
